// src/components/header.js

import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, IconButton, Box, Drawer, List, ListItemButton, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';

const logo = `${process.env.PUBLIC_URL}/img/logo.png`;
const navItems = ['Home', 'About', 'Gallery', 'Contact'];

const StyledAppBar = styled(AppBar)`
  transition: height 0.3s ease, box-shadow 0.3s ease;
  background-color: white !important;
  box-shadow: ${({ $scroll }) => ($scroll ? '0 4px 14px rgba(0, 0, 0, 0.1)' : 'none')};
  height: ${({ $scroll }) => ($scroll ? '62px' : '85px')};
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;

  @media (max-width: 768px) {
    height: 72px;
  }
`;

const Logo = styled.img`
  height: ${({ $scroll }) => ($scroll ? '48px' : '68px')};
  transition: height 0.3s ease;
  display: block;

  @media (max-width: 768px) {
    height: 56px;
  }
`;

const Links = styled(Box)`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  gap: 20px;

  a {
    text-decoration: none;
    color: black;
    font-weight: bold;
    transition: color 0.3s ease, font-size 0.3s ease;
    font-size: ${({ $scroll }) => ($scroll ? '0.95rem' : '1.05rem')};
    &:hover {
      color: #b58322;
    }
    &.active {
      color: #805d17;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const SocialLinks = styled(Box)`
  display: flex;
  gap: 10px;

  a {
    text-decoration: none;
    color: black;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileMenuButton = styled(IconButton)`
  color: black !important;
`;

const MobileMenuLinks = styled(List)`
  a {
    text-decoration: none;
    color: black;
    font-weight: bold;
    transition: color 0.3s ease;
    &:hover {
      color: #b58322;
    }
  }
`;

const Header = () => {
  const [scroll, setScroll] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const hasScrolled = window.scrollY > 50;
      setScroll((current) => (current === hasScrolled ? current : hasScrolled));
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const list = () => (
    <MobileMenuLinks
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {navItems.map((text) => (
          <ListItemButton key={text} component={Link} to={text === 'Home' ? '/' : `/${text.toLowerCase()}`}>
            <ListItemText primary={text} />
          </ListItemButton>
        ))}
      </List>
    </MobileMenuLinks>
  );

  return (
    <StyledAppBar position="fixed" $scroll={scroll}>
      <Toolbar style={{ justifyContent: 'space-between' }}>
        <IconButton edge="start" color="inherit" aria-label="Go to homepage">
          <Link to="/">
            <Logo src={logo} alt="Gallery J Logo" $scroll={scroll} />
          </Link>
        </IconButton>

        <Links $scroll={scroll}>
          <NavLink to="/">HOME</NavLink>
          <NavLink to="/about">ABOUT</NavLink>
          <NavLink to="/gallery">GALLERY</NavLink>
          <NavLink to="/contact">CONTACT</NavLink>
        </Links>

        <SocialLinks>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
        </SocialLinks>

        <MobileMenuButton edge="end" aria-label="menu" onClick={toggleDrawer(true)} sx={{ display: { md: 'none' } }}>
          <MenuIcon />
        </MobileMenuButton>

        <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
          {list()}
        </Drawer>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;
